module.exports = __webpack_public_path__ + "img/illustrations-API.52a61e15.svg";